export default function PassageText({ passage }) {
  return (
    <div className="prose prose-lg max-w-none bg-white p-6 rounded-xl shadow-lg">
      <h1 className="font-anton text-2xl text-primary mb-4">{passage.title}</h1>
      <div
        className="leading-relaxed text-justify font-poppins text-gray-800"
        dangerouslySetInnerHTML={{
          __html: passage.content.replace(/\n/g, '<br>'),
        }}
      />
    </div>
  );
}